"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var VInlineInputEditor_vue_1 = __importDefault(require("../scraps/VInlineInputEditor.vue"));
var VIcon_vue_1 = __importDefault(require("../scraps/VIcon.vue"));
var vue_class_component_1 = __importStar(require("vue-class-component"));
var VInlineDropdownSelectEditor_vue_1 = __importDefault(require("../scraps/VInlineDropdownSelectEditor.vue"));
var vue_property_decorator_1 = require("vue-property-decorator");
var PermissionsMixin_1 = __importDefault(require("../../mixins/request/PermissionsMixin"));
var FirstNameInput_vue_1 = __importDefault(require("../form/FirstNameInput.vue"));
var LastNameInput_vue_1 = __importDefault(require("../form/LastNameInput.vue"));
var RegistrationNumberInput_vue_1 = __importDefault(require("../form/RegistrationNumberInput.vue"));
var UnitSelect_vue_1 = __importDefault(require("../form/UnitSelect.vue"));
var DistrictSelect_vue_1 = __importDefault(require("../form/DistrictSelect.vue"));
var event_bus_1 = require("../../event-bus");
var JoinedAtInput_vue_1 = __importDefault(require("../form/JoinedAtInput.vue"));
var QuitAtInput_vue_1 = __importDefault(require("../form/QuitAtInput.vue"));
var TableHeader_1 = __importDefault(require("../../classes/TableHeader"));
var permissions_json_1 = __importDefault(require("../../../permissions.json"));
var VButton_vue_1 = __importDefault(require("../scraps/VButton.vue"));
var ArchiveScout_vue_1 = __importDefault(require("./ArchiveScout.vue"));
var RemarksInput_vue_1 = __importDefault(require("../form/RemarksInput.vue"));
var ContributionCheckbox_vue_1 = __importDefault(require("./ContributionCheckbox.vue"));
var VContributionStatus_vue_1 = __importDefault(require("../scraps/VContributionStatus.vue"));
var __ = window.$lang;
var ScoutsTable = /** @class */ (function (_super) {
    __extends(ScoutsTable, _super);
    function ScoutsTable() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = "scouts-table";
        _this.components = {
            LastNameInput: LastNameInput_vue_1.default,
            FirstNameInput: FirstNameInput_vue_1.default,
            RegistrationNumberInput: RegistrationNumberInput_vue_1.default,
            DistrictSelect: DistrictSelect_vue_1.default,
            UnitSelect: UnitSelect_vue_1.default,
            JoinedAtInput: JoinedAtInput_vue_1.default,
            QuitAtInput: QuitAtInput_vue_1.default,
            RemarksInput: RemarksInput_vue_1.default
        };
        return _this;
    }
    Object.defineProperty(ScoutsTable.prototype, "headers", {
        get: function () {
            var _this = this;
            var yearStart = this.$store.state.settings.CONTRIBUTIONS_YEAR_START;
            var yearEnd = this.$store.state.settings.CONTRIBUTIONS_YEAR_END;
            var yearsHeaders = [];
            for (var i = yearStart; i <= yearEnd; i++) {
                yearsHeaders.push(new TableHeader_1.default(i, "center"));
            }
            return __spreadArrays([
                new TableHeader_1.default(__("Lp.")),
                new TableHeader_1.default(__("Nazwisko")),
                new TableHeader_1.default(__("Imię")),
                new TableHeader_1.default(__("Nr ewidencyjny"), "left", function () { return _this.can(permissions_json_1.default.scouts.registrationNumber.view); }),
                new TableHeader_1.default(__("Hufiec"), "left", this.districts.length > 1),
                new TableHeader_1.default(__("Jednostka")),
                new TableHeader_1.default(__("DD"))
            ], yearsHeaders, [
                new TableHeader_1.default(__("Uwagi")),
                new TableHeader_1.default(__("DW")),
                new TableHeader_1.default(__("Akcje"), "center", function () { return !_this.archived; })
            ]);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ScoutsTable.prototype, "years", {
        get: function () {
            var yearStart = this.$store.state.settings.CONTRIBUTIONS_YEAR_START;
            var yearEnd = this.$store.state.settings.CONTRIBUTIONS_YEAR_END;
            var years = [];
            for (var i = yearStart; i <= yearEnd; i++) {
                years.push(i);
            }
            return years;
        },
        enumerable: true,
        configurable: true
    });
    ScoutsTable.prototype.getScoutDistrictOption = function (district_id) {
        var district = this.districts.find(function (district) { return district.id === district_id; });
        return district ? {
            value: district_id,
            name: district.name
        } : {};
    };
    ScoutsTable.prototype.onScoutUpdate = function (scout_id, attribute, value) {
        event_bus_1.EventBus.$emit(event_bus_1.events.scout.update, { scout_id: scout_id, attribute: attribute, value: value });
    };
    __decorate([
        vue_property_decorator_1.Prop({ required: true })
    ], ScoutsTable.prototype, "scouts", void 0);
    __decorate([
        vue_property_decorator_1.Prop({ required: true })
    ], ScoutsTable.prototype, "districts", void 0);
    __decorate([
        vue_property_decorator_1.Prop({ required: true })
    ], ScoutsTable.prototype, "units", void 0);
    __decorate([
        vue_property_decorator_1.Prop({ required: true })
    ], ScoutsTable.prototype, "pagination", void 0);
    __decorate([
        vue_property_decorator_1.Prop({ required: true })
    ], ScoutsTable.prototype, "archived", void 0);
    __decorate([
        vue_property_decorator_1.Prop({ required: true })
    ], ScoutsTable.prototype, "displayState", void 0);
    ScoutsTable = __decorate([
        vue_class_component_1.default({ components: {
                VContributionStatus: VContributionStatus_vue_1.default,
                ContributionCheckbox: ContributionCheckbox_vue_1.default,
                ArchiveScout: ArchiveScout_vue_1.default,
                VInlineInputEditor: VInlineInputEditor_vue_1.default,
                VInlineDropdownSelectEditor: VInlineDropdownSelectEditor_vue_1.default,
                VIcon: VIcon_vue_1.default,
                VButton: VButton_vue_1.default
            } })
    ], ScoutsTable);
    return ScoutsTable;
}(vue_class_component_1.mixins(PermissionsMixin_1.default)));
exports.default = ScoutsTable;
